module.exports = __webpack_public_path__ + "static/media/wide.ae906574.jpg";